<template>
  <mdc-dialog class="bids-modal"
              v-model="isOpen"
              :title="'dashboard.requestHelp' | trans"
              @cancel="close">

    <div class="close-cross" @click="close()">
      <mdc-icon icon="close"></mdc-icon>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <p class="text-center">{{'dashboard.functionalInDevelopment' | trans}}</p>
      </div>
    </div>


    <footer class="mdc-dialog__footer mdc-dialog__footer--visible">
      <button type="button" class="mdc-button mdc-button--raised button-primary" @click="onSendRequestButtonClick()"> {{'bids.buttons.sendRequest' | trans}}</button>
    </footer>
  </mdc-dialog>
</template>

<script>

  export default {
    name: 'requestHelpModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {

      };
    },
    methods: {
      onSendRequestButtonClick() {
        this.validate();
      },

      sendRequest(apiManager, clientId) {
        try {
          this.close();
        } catch (e) {
          console.error('Unknown API error occurred.');
        }
      },

      async validate() {
        let result = await this.$validator.validateAll();

      },

      close() {
        this.$emit('close');
      },
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        }
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/modules/dashboardModal/components/requestHelpModal.vue